// removed by extract-text-webpack-plugin
module.exports = {"nprogress-spinner":"_8WRxm"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/App/nprogress.scss
// module id = 837
// module chunks = 34